<template>
  <FormDialog v-if="showRequest" @emitShow="dialogClose" />
</template>

<script>
import FormDialog from '@/components/wholesaler/FormDialog'

export default {
  components: {
    FormDialog,
  },
  data() {
    return {
      showRequest: true,
      saler: null,
    }
  },
  async created() {},
  computed: {},
  watch: {},
  methods: {
    dialogClose(result) {
      setTimeout(() => {
        this.$router.go(-1)
      }, 50)
    },
  },
}
</script>
